import React from "react";
import { inject, observer } from "mobx-react";
import QuestionDetailsContainer from "./question/QuestionDetailsContainer";
import classNames from "classnames";
import { Link } from "react-router-dom";

import QuizInfo from "components/providers/online_workshop_details/quiz/QuizInfo";
import QuillEditor from 'components/create_workshop/QuillEditor';
import {EditorState} from "draft-js";
import HttpClient from "services/HttpClient";
import Modal from 'react-modal';

const customStyles = {
  content : {
      margin: '0',
      position: 'fixed',
      top: '50%',
      left: '50%',
      width: '100%',
      maxWidth: '500px',
      height: 'fit-content',
      background: 'transparent',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      border: 'none',
      outline: 'none',
      padding: '0',
      transform: 'translate(-50%,-50%)'
  }
};

const SUBMIT_MODULE = '/api/v1/modules/submit_module/?module_id=';

@inject("workshopDetails")
@inject("modal")
@inject("user")
@observer
export default class WorkshopContent extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      isLoader: false,
      modalOpened: false,
    }
  }

  componentWillReceiveProps(newProps) {
    if( newProps.description !== this.props.description || newProps.index !== this.props.index) {
      this.setState({isLoader: true})
      setTimeout(() => {
        this.setState({isLoader: false})
      },  4000);
    }
  }

  closeModal = () => {
    this.setState({
      ...this.state,
      modalOpened: false
    });
  }

  submitModule = () => {
    new HttpClient()
    .post(
      SUBMIT_MODULE +
        this.props.workshopDetails.workshop.modules[this.props.index].id
    )
    .then(data => {
      this.props.workshopDetails.setCompletedModule(
        this.props.workshopDetails.workshop.modules[this.props.index].id
      );
      this.props.workshopDetails.changeOpenedType({
        type: "none",
        index: -1
      });
      if (data.body.completed) {
        this.setState({
          ...this.state,
          modalOpened: true
        });
      };
    });
  }

  startQuiz = () => {
    const {workshopDetails, handleTriggerClick, onOpen} = this.props;
    const {workshop} = workshopDetails;
    const quizModule = workshop.modules.filter(module => module.module_type === 'quiz' && module.status !== 'module_completed')[0];
    const moduleIdx = workshop.modules.map(module => module.id).indexOf(quizModule.id);
    handleTriggerClick(moduleIdx, 'module');
    onOpen();
    document
      .getElementsByClassName(`quizinfo-container ${moduleIdx + 1}`)[0]
      .scrollIntoView(false);
  };

  getStatus = status => {
    switch(status) {
      case 'workshop_completed':
        return 'Completed';
      case 'workshop_not_started':
        return 'Incomplete';
      case 'workshop_trainee_progress':
        return 'In Progress';
      case 'workshop_check_response':
        return 'Incomplete';
      default:
        return '';
    }
  }

  render() {
    let documents = [];
    let model;
    const {description, type, user, workshopDetails} = this.props;
    const showWorkshopStatus = this.props.type === "workshop" && user.user && workshopDetails.workshop.created_by !== user.user.id && user.user.role !== 'admin' && workshopDetails.workshop.status;
    if (this.props.type === "workshop") {
      model = this.props.workshopDetails.workshop;
      if (model.more_info_url)
        documents = [
          {
            url: model.more_info_url,
            file_name: model.more_info_file_name,
            file_size: model.more_info_file_size
          }
        ];
    }
    if (this.props.type === "module") {
      model = this.props.workshopDetails.workshop.modules[this.props.index];
      if (model.attachments)
        model.attachments.forEach(el => {
          documents.push({
            url: el.document_url,
            file_name: el.document_file_name,
            file_size: el.document_file_size
          });
        });
    }
    const desc = model.description || description;
    const quizModule = this.props.workshopDetails.workshop.modules.filter(module => module.module_type === 'quiz' && module.status !== 'module_completed')[0];
    return (
      <div className="regular-workshop-content">
        <div className="regular-workshop-module">
          <div
            className="regular-workshop-module-head"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 className="regular-workshop-module-title">{model.title}</h2>
            {type === 'workshop' && quizModule && this.props.user.user && this.props.user.getUser().role !== "admin" && (
              <span className="btn bordered blue empty quiz" onClick={this.startQuiz}>
                take quiz
              </span>
            )}
            {showWorkshopStatus && (
              <span
                className={classNames('list-workshops-status', {
                  completed: workshopDetails.workshop.status === 'workshop_completed' || workshopDetails.workshop.status === 'workshop_check_response'
                })}
              >
                {this.getStatus(workshopDetails.workshop.status)}
              </span>
            )}
          </div>
          {/* {this.state.isLoader ?
            <div className="loader_block">
              <div className="loader"> {console.log('LOADER' )}</div>
            </div>
            :
            <QuillEditor
              theme={null}
              value={model.description || description}
              readOnly={true}
            />
          } */}
          {this.state.isLoader && (
            <div className="loader_block">
              <div className="loader"> {console.log('LOADER' )}</div>
            </div>
          // ) : (
            // <div dangerouslySetInnerHTML={{__html: desc}} />
          )}
          <div style={{visibility: this.state.isLoader ? 'hidden' : 'visible'}} dangerouslySetInnerHTML={{__html: desc}} />
          {localStorage.getItem('haveAccess') ? (
            <div
              className="regular-workshop-module-footer attachments-file"
              style={{ marginBottom: 20 }}
            >
              <p className="regular-workshop-additional">
                WEBINAR LINK:
              </p>
              <a href={model.zoom_link} target="_blank">{model.zoom_link}</a>
            </div>
          ) : null}

          {documents.length !== 0 && (
            <div
              className="regular-workshop-module-footer attachments-file"
              style={{ marginBottom: 20 }}
            >
              <p className="regular-workshop-additional">
                ADDITIONAL INFORMATION:
              </p>
              <ul className="file-list editing">
                {documents.map((el, index) => (
                  <a
                    href={el.url}
                    download={true}
                    key={index}
                    className="file-link-active"
                  >
                    <li className="file-item" key={index}>
                      <div
                        className="file-item-inner"
                        style={{ height: "50px" }}
                      >
                        <i className="ic-file-ico file-icon" />
                        <div className="file-link">
                          {el.file_name}
                          <span className="file-link-size">
                            {parseInt(el.file_size / 1024)} KB
                          </span>
                        </div>
                      </div>
                    </li>
                  </a>
                ))}
              </ul>
            </div>
          )}

          <div className="question-accordion">
            {this.props.type === "module" && this.props.moduleType !== "quiz" && !this.props.is_hidden
              ? model.questions.map((el, index) => (
                  <QuestionDetailsContainer
                    moduleId={this.props.index}
                    questionId={index}
                    key={index}
                  />
                ))
              : null}
          </div>

          <div>
            {this.props.moduleType === "quiz" && !this.props.is_hidden ? (
              <QuizInfo moduleIdx={this.props.index} />
            ) : null}
          </div>
          {this.props.moduleType === 'other' && this.props.workshopDetails.workshop.modules[this.props.index].status !== 'module_completed' &&
            <div
              className={"quizinfo-wrapper"}
              style={{textAlign: 'center'}}
            >
              <button className="btn prime bordered" onClick={this.submitModule}>
                I have completed this module
              </button>
            </div>
          }
        </div>
        <Modal
          isOpen={this.state.modalOpened}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.closeModal}
        >
          <div className="quiz-modal">
            <div className="qm-message">
              <p>Congratulations, you have now completed the Workshop.</p>
              <p><Link to={ this.props.user.user && this.props.user.user.role === 'iacp' ? '/iacp/completed' : '/completed_workshops'} className='alert-underlined-link'>Click here</Link><span> to view your CPD cert for this Workshop.</span></p>
            </div>
            <div className="qm-close">
              <button onClick={this.closeModal}><i className="ic-close-ico"/></button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/WorkshopContent.jsx